<template>
  <div class="center-pill align-content-center">
    <v-layout align-content-center class="mt-2 justify-center">
      <v-row justify="center">
        <v-col v-for="(item, index) in besthit"  :key="index" cols="12" lg="2" md="3" sm="2">
          <v-card @click="gosellerpage(item.sellerid)" class="ma-2" elevation="1">
            <v-card-subtitle class="headerbesthit white--text text-center">{{item.operator}}</v-card-subtitle>
            <v-card-text  class="align-center align-content-center mt-3 text-center">
              <div class="dark mb-1"><h3>{{potongnama(item.sellername)}}</h3></div>
              <img class="imgavatarbest" alt="a" width="90px" height="90px" :src="item.selleravatar"/>
              <!---<div class="dark">Transaksi</div>
               <div class="dark"><h3>{{formatAngka(item.total)}}</h3></div> -->
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import Utils from '@/plugins/utils'
import { mapActions, mapState } from 'vuex'
import S from 'string'

export default {
  name: 'BlocBestHit',
  data: () => ({
  }),
  mounted () {
    this.getBestHit()
  },
  computed: {
    ...mapState('ProductStore', ['besthit'])
  },
  methods: {
    ...mapActions('ProductStore', ['getBestHit']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    gosellerpage (id) {
      this.$router.push('/supplier/' + id)
    },
    potongnama (val) {
      if (val.length > 20) {
        return S(val).left(20).replaceAll('`', '').replaceAll("'", '').s
      } else {
        return val.toUpperCase()
      }
    }
  }
}
</script>

<style scoped>
.headerbesthit{
  background: linear-gradient(to right, #308521 , #2e3147);
  padding: 10px;
  color: #ffffff;
  border-radius: 5px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  font-weight: bold;
}
.imgavatarbest {
  position: relative;
  border-radius: 10px;
}
</style>
